const OPEN_SIDE_BAR = 'OPEN_SIDE_BAR'
const CLOSE_SIDE_BAR = 'CLOSE_SIDE_BAR'
const OPEN_CARS_SECOND_SIDE_BAR = 'OPEN_CARS_SECOND_SIDE_BAR'
const CLOSE_CARS_SECOND_SIDE_BAR = 'CLOSE_CARS_SECOND_SIDE_BAR'
const OPEN_DRIVERS_SECOND_SIDE_BAR = 'OPEN_DRIVERS_SECOND_SIDE_BAR'
const CLOSE_DRIVERS_SECOND_SIDE_BAR = 'CLOSE_DRIVERS_SECOND_SIDE_BAR'

const openSideBarAction = () => {
  return {
    type: OPEN_SIDE_BAR,
  }
}

const closeSideBarAction = () => {
  return {
    type: CLOSE_SIDE_BAR,
  }
}

const openCarsSecondSideBar = () => {
  return {
    type: OPEN_CARS_SECOND_SIDE_BAR,
  }
}

const closeCarsSecondSideBar = () => {
  return {
    type: CLOSE_CARS_SECOND_SIDE_BAR,
  }
}

const openDriversSecondSideBar = () => {
  return {
    type: OPEN_DRIVERS_SECOND_SIDE_BAR,
  }
}

const closeDriversSecondSideBar = () => {
  return {
    type: CLOSE_DRIVERS_SECOND_SIDE_BAR,
  }
}

export {
  openSideBarAction,
  closeSideBarAction,
  openCarsSecondSideBar,
  closeCarsSecondSideBar,
  openDriversSecondSideBar,
  closeDriversSecondSideBar,
  OPEN_SIDE_BAR,
  CLOSE_SIDE_BAR,
  OPEN_CARS_SECOND_SIDE_BAR,
  CLOSE_CARS_SECOND_SIDE_BAR,
  OPEN_DRIVERS_SECOND_SIDE_BAR,
  CLOSE_DRIVERS_SECOND_SIDE_BAR,
}
